<template>
  <modal
    title="Settings"
    :open="open"
    @close="closeModal"
  >
    <form @submit.stop.prevent="submit">
      <align small-gap>
        <text-input
          v-model.trim="name"
          label="Collection Name"
          maxlength="50"
        />

        <btn
          type="submit"
          class="submit-button"
          :loading="submitting"
          :disabled="disabled"
          loading-text="Submitting"
        >
          Save
        </btn>
      </align>
    </form>

    <div class="button-row">
      <btn
        kind="secondary"
        @click="exportCollection"
      >
        Export CSV
      </btn>

      <btn
        v-if="allowDelete"
        kind="error"
        class="delete-button"
        :disabled="deleting"
        @click="deleteCollection"
      >
        Delete Collection
      </btn>
    </div>
  </modal>
</template>

<script>
import { mapState } from 'vuex';
import * as Sentry from '@sentry/vue';

import { authService } from '@/services';

export default {
  props: {
    open: Boolean,
  },

  data() {
    return {
      name: '',
      submitting: false,
      deleting: false,
    };
  },

  mounted() {
    this.name = this.collection?.name || '';
  },

  watch: {
    'collection.name': function(value) {
      this.name = value;
    },
  },

  computed: {
    ...mapState({
      user: (state) => state.user,
      collection: (state) => state.collection,
      collections: (state) => state.collections,
    }),

    disabled() {
      return !this.name;
    },

    allowDelete() {
      return this.collections && this.collections.length > 1;
    },
  },

  methods: {
    async submit() {
      this.submitting = true;

      try {
        await authService.updateCollectionName(this.user.uid, this.collection.id, this.name);
        this.$toasted.success('Updated your collection name!');
        this.closeModal();
      } catch (e) {
        this.$toasted.error('Error updating your collection name');
        Sentry.captureException(e);
      }

      this.submitting = false;
    },

    async exportCollection() {
      if (window.confirm('Are you sure you want to export your collection as CSV? This will download files to your computer.')) {
        try {
          await authService.exportCollection(this.user.uid, this.collection.id);
          this.closeModal();
        } catch (e) {
          this.$toasted.error('Error exporting your collection');
          Sentry.captureException(e);
        }
      }
    },

    deleteCollection() {
      if (window.confirm('Are you sure you want to delete this collection? All your cards and information will be deleted forever and there is no recovering. Please be absolutely sure.')) {
        if (window.confirm('One last chance before this collection is completely gone. Are you sure?')) {
          this.deleting = true;

          try {
            authService.deleteCollection(this.user.uid, this.collection.id);
            this.$toasted.success('The collection has been deleted!');
            this.$emit('deleted', this.collection.id);
            this.closeModal();
          } catch (e) {
            this.$toasted.error('Failed to delete your collection');
            Sentry.captureException(e);
          }

          this.deleting = false;
        }
      }
    },

    closeModal() {
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>
.button-row {
  width: 100%;

  .delete-button {
    margin-left: auto;
  }
}

.submit-button {
  margin-bottom: $gp;
}
</style>
